import React from 'react'
import { Button, Row, Tag } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import { useFeatureFlag } from '@fs/zion-flags'

export default function CetActions({
  treeId,
  fileStatus,
  isProcessingOrLoading,
  isPrivateTree,
  isMobile,
  isManageTree,
  groupId,
  isResearcherTree,
}) {
  const [t] = useTranslation()
  const showReviewMatches = useFeatureFlag('treeWeb_importR9TreeMatches').isOn
  if (!treeId) return null
  return (
    <Row wrap guttersY="pico" guttersX="md" alignX={isMobile ? 'start' : 'end'} alignY="middle">
      {isResearcherTree && (
        <>
          {isPrivateTree && !isProcessingOrLoading ? (
            <Tag text={t('tree-import.private-tree')} color="yellow" data-testid="private-tree-tag" />
          ) : (
            <Button
              data-testid="review-matches-button"
              noShrinkX
              disabled={!showReviewMatches || (showReviewMatches && isProcessingOrLoading)}
              disabledDescription={showReviewMatches ? undefined : t('Review matches coming soon')}
              to={showReviewMatches ? `/matches/${treeId}` : undefined}
              linkName="review matches button"
            >
              {t('tree-import.review-matches.button')}
            </Button>
          )}
        </>
      )}
      {isManageTree ? (
        <Button
          noShrinkX
          data-testid="view-tree-settings-button"
          to={isResearcherTree ? `/research-tree/${groupId}/details` : `/family/${groupId}/details?from=manage-trees`}
          linkName="view-settings-button"
          disabled={fileStatus === 'IMPORTING'}
        >
          {t('tree-import.upload-trees.view-settings')}
        </Button>
      ) : (
        <Button
          noShrinkX
          data-testid="gedcom-upload-view-personal-tree-button"
          to={`/tree/pedigree?treeId=${treeId}`}
          linkName="view-tree-button"
          disabled={fileStatus === 'IMPORTING'}
          external
        >
          {t('tree-import.upload-trees.view-tree')}
        </Button>
      )}
    </Row>
  )
}
